/* =========================================================================
   LC Quick Add  —  "+" button / Add To Cart with Quick View sheet
   - Single-variant products: adds straight to cart, opens cart drawer.
   - Multi-variant products: opens a "CHOOSE OPTIONS" quick view
     (bottom sheet on mobile, centered modal on desktop).
   Used by: featured-collection-lgnd, featured-collection-nofc,
            main-collection-lgnd, main-collection-nofc, cart drawer upsells.
   ========================================================================= */
(function () {
  'use strict';

  if (customElements.get('lc-quick-add')) return;

  var COLOR_MAP = {
    black: '#111111', white: '#ffffff', red: '#e02b2b', blue: '#2563eb',
    navy: '#1e2a4a', green: '#3f7d3f', 'military green': '#5c6b46',
    'army green': '#4b5320', olive: '#708238', 'olive green': '#708238',
    orange: '#f97316', brown: '#7b4a21', 'coyote brown': '#81613c',
    pink: '#ec6a9c', purple: '#8b5cf6', yellow: '#eab308', grey: '#8a8a8a',
    gray: '#8a8a8a', charcoal: '#3a3a3a', tan: '#d2b48c', gold: '#c9a24b',
    silver: '#c0c0c0', teal: '#14b8a6', maroon: '#7f1d1d', beige: '#e8dcc8',
    cream: '#f3ead8', 'off-white': '#f3f1ea', 'off white': '#f3f1ea',
    khaki: '#b7a87a', burgundy: '#6d1a2d', mint: '#9fe2bf', coral: '#ff7f50',
    turquoise: '#40e0d0', lavender: '#b57edc', camo: '#5c6b46'
  };

  function moneyFormat() {
    return window.lcMoneyFormat || '${{amount}}';
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var format = moneyFormat();

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    var match = format.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    switch (key) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  function numberWithCommas(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function sized(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  /* ------------------------------------------------------------------ */
  /*  Add to cart + refresh the theme cart (drawer or notification)      */
  /* ------------------------------------------------------------------ */
  function themeCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function sectionsFor(cartEl) {
    if (!cartEl) return [];
    if (cartEl.tagName === 'CART-DRAWER') return ['cart-drawer', 'cart-icon-bubble'];
    return ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
  }

    function addToCart(variantId, quantity, sellingPlanId) {
    var cartEl = themeCart();
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', quantity || 1);
    if (sellingPlanId) {
      body.append('selling_plan', sellingPlanId);
    }
    if (cartEl) {
      body.append('sections', sectionsFor(cartEl).join(','));
      body.append('sections_url', window.location.pathname);
    }

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    return fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'Could not add to cart');
        }
        if (cartEl && typeof cartEl.renderContents === 'function') {
          if (typeof cartEl.setActiveElement === 'function') {
            cartEl.setActiveElement(document.activeElement);
          }
          cartEl.renderContents(response);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
        if (window.publish && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
          try {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'lc-quick-add',
              productVariantId: variantId,
              cartData: response
            });
          } catch (e) { /* noop */ }
        }
        return response;
      });
  }

  /* ------------------------------------------------------------------ */
  /*  Quick view (single global instance)                                */
  /* ------------------------------------------------------------------ */
  var quickView = null;

  function getQuickView() {
    if (quickView) return quickView;
    quickView = document.createElement('div');
    quickView.className = 'lc-qv';
    quickView.innerHTML =
      '<div class="lc-qv__overlay" data-lc-qv-close></div>' +
      '<div class="lc-qv__panel" role="dialog" aria-modal="true" aria-label="Choose options">' +
      '  <div class="lc-qv__header">' +
      '    <h2 class="lc-qv__title">Choose Options</h2>' +
      '    <button type="button" class="lc-qv__close" data-lc-qv-close aria-label="Close">' +
      '      <svg viewBox="0 0 18 18" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M2 2l14 14M16 2L2 16"/></svg>' +
      '    </button>' +
      '  </div>' +
      '  <div class="lc-qv__scroll">' +
      '    <div class="lc-qv__media">' +
      '      <button type="button" class="lc-qv__arrow lc-qv__arrow--prev" aria-label="Previous image"><svg viewBox="0 0 10 16" width="10" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 1.5 2 8l6.5 6.5"/></svg></button>' +
      '      <div class="lc-qv__track"></div>' +
      '      <button type="button" class="lc-qv__arrow lc-qv__arrow--next" aria-label="Next image"><svg viewBox="0 0 10 16" width="10" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1.5 1.5 8 8l-6.5 6.5"/></svg></button>' +
      '    </div>' +
      '    <div class="lc-qv__name"></div>' +
      '    <div class="lc-qv__price"></div>' +
      '    <div class="lc-qv__entries"></div>' +
      '    <div class="lc-qv__options"></div>' +
      '  </div>' +
      '  <div class="lc-qv__footer">' +
      '    <p class="lc-qv__error" role="alert" hidden></p>' +
      '    <button type="button" class="lc-qv__atc button">Add To Cart</button>' +
      '  </div>' +
      '</div>';
    document.body.appendChild(quickView);

    quickView.addEventListener('click', function (e) {
      if (e.target.closest('[data-lc-qv-close]')) closeQuickView();
    });
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && quickView.classList.contains('is-open')) closeQuickView();
    });

    quickView.querySelector('.lc-qv__arrow--prev').addEventListener('click', function () { scrollMedia(-1); });
    quickView.querySelector('.lc-qv__arrow--next').addEventListener('click', function () { scrollMedia(1); });
    quickView.querySelector('.lc-qv__atc').addEventListener('click', onQuickViewAdd);

    return quickView;
  }

    var state = { product: null, selected: [], entries: 0, multiplier: 0, tier: '', sellingPlanId: null };

  function scrollMedia(dir) {
    var track = quickView.querySelector('.lc-qv__track');
    track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
  }

  function openQuickView(product, meta) {
    var qv = getQuickView();
    state.product = product;
    state.entries = meta.entries || 0;
    state.multiplier = meta.multiplier || 0;
        state.tier = meta.tier || 'badge-red';
    state.sellingPlanId = meta.sellingPlanId || null;

    var firstAvailable = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) { firstAvailable = product.variants[i]; break; }
    }
    var base = firstAvailable || product.variants[0];
    state.selected = [base.option1, base.option2, base.option3].filter(function (v) { return v != null; });

    /* media */
    var track = qv.querySelector('.lc-qv__track');
    track.innerHTML = '';
    var images = product.images && product.images.length ? product.images : [];
    if (!images.length && product.featured_image) images = [product.featured_image];
    images.forEach(function (src) {
      var slide = document.createElement('div');
      slide.className = 'lc-qv__slide';
      var img = document.createElement('img');
      img.src = sized(src, 720);
      img.alt = product.title;
      img.loading = 'lazy';
      slide.appendChild(img);
      track.appendChild(slide);
    });
    qv.querySelector('.lc-qv__media').classList.toggle('lc-qv__media--single', images.length < 2);

    qv.querySelector('.lc-qv__name').textContent = product.title;

    /* entries badge */
    var entriesWrap = qv.querySelector('.lc-qv__entries');
    if (state.entries > 0) {
      entriesWrap.innerHTML =
        '<span class="lc-entries ' + state.tier + '">' +
        '  <span class="lc-entries__count">' + numberWithCommas(state.entries) + ' Entries</span>' +
        (state.multiplier > 0 ? '<span class="lc-entries__multiplier">' + state.multiplier + 'X</span>' : '') +
        '</span>';
      entriesWrap.hidden = false;
    } else {
      entriesWrap.innerHTML = '';
      entriesWrap.hidden = true;
    }

    buildOptions();
    syncVariant();

    var err = qv.querySelector('.lc-qv__error');
    err.hidden = true; err.textContent = '';

    qv.classList.add('is-open');
    document.body.classList.add('lc-qv-open');
    setTimeout(function () { qv.querySelector('.lc-qv__close').focus(); }, 60);
  }

  function closeQuickView() {
    if (!quickView) return;
    quickView.classList.remove('is-open');
    document.body.classList.remove('lc-qv-open');
  }

  function isColorOption(name) {
    return /colou?r/i.test(name);
  }

  function swatchColor(value) {
    var key = String(value).trim().toLowerCase();
    if (COLOR_MAP[key]) return COLOR_MAP[key];
    if (window.CSS && CSS.supports && CSS.supports('color', key)) return key;
    var compact = key.replace(/[\s-]/g, '');
    if (CSS.supports && CSS.supports('color', compact)) return compact;
    return null;
  }

  function buildOptions() {
    var qv = quickView;
    var wrap = qv.querySelector('.lc-qv__options');
    wrap.innerHTML = '';
    var product = state.product;
    if (product.variants.length <= 1 && (!product.options || product.options.length === 0)) return;

    (product.options || []).forEach(function (opt, optIndex) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var values = typeof opt === 'string' ? uniqueValues(optIndex) : (opt.values || uniqueValues(optIndex));
      if (values.length === 1 && values[0] === 'Default Title') return;

      var block = document.createElement('div');
      block.className = 'lc-qv__opt';

      var label = document.createElement('p');
      label.className = 'lc-qv__opt-label';
      block.appendChild(label);

      var list = document.createElement('div');
      list.className = 'lc-qv__opt-values' + (isColorOption(name) ? ' lc-qv__opt-values--swatch' : '');
      block.appendChild(list);

      values.forEach(function (value) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.dataset.optIndex = optIndex;
        btn.dataset.value = value;
        if (isColorOption(name)) {
          btn.className = 'lc-qv__swatch';
          var c = swatchColor(value);
          if (c) {
            btn.style.background = c;
            if (/^#f|^whi|^cream|^beige|^off/i.test(String(value).toLowerCase()) || c === '#ffffff') {
              btn.classList.add('lc-qv__swatch--light');
            }
          } else {
            btn.classList.add('lc-qv__swatch--unknown');
          }
          btn.setAttribute('aria-label', value);
          btn.title = value;
        } else {
          btn.className = 'lc-qv__pill';
          btn.textContent = value;
        }
        btn.addEventListener('click', function () {
          state.selected[optIndex] = value;
          syncVariant();
        });
        list.appendChild(btn);
      });

      wrap.appendChild(block);

      function refreshLabel() {
        label.textContent = name + ': ' + (state.selected[optIndex] || '');
      }
      block.dataset.lcRefresh = '1';
      block._lcRefreshLabel = refreshLabel;
      refreshLabel();
    });
  }

  function uniqueValues(optIndex) {
    var seen = [];
    state.product.variants.forEach(function (v) {
      var val = v['option' + (optIndex + 1)];
      if (val != null && seen.indexOf(val) === -1) seen.push(val);
    });
    return seen;
  }

  function currentVariant() {
    var sel = state.selected;
    var match = null;
    state.product.variants.forEach(function (v) {
      var ok = true;
      for (var i = 0; i < sel.length; i++) {
        if (v['option' + (i + 1)] !== sel[i]) { ok = false; break; }
      }
      if (ok) match = v;
    });
    return match;
  }

  function syncVariant() {
    var qv = quickView;
    var variant = currentVariant();

    /* selected states */
    qv.querySelectorAll('.lc-qv__pill, .lc-qv__swatch').forEach(function (btn) {
      var idx = parseInt(btn.dataset.optIndex, 10);
      btn.classList.toggle('is-selected', state.selected[idx] === btn.dataset.value);
    });
    qv.querySelectorAll('.lc-qv__opt').forEach(function (block) {
      if (block._lcRefreshLabel) block._lcRefreshLabel();
    });

    /* price */
    var priceEl = qv.querySelector('.lc-qv__price');
    if (variant) {
      var html = '<span class="lc-qv__price-current">' + formatMoney(variant.price) + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += ' <s class="lc-qv__price-compare">' + formatMoney(variant.compare_at_price) + '</s>';
      }
      priceEl.innerHTML = html;
    } else {
      priceEl.innerHTML = '';
    }

    /* media jump to variant image */
    if (variant && variant.featured_image && variant.featured_image.src) {
      var track = qv.querySelector('.lc-qv__track');
      var imgs = track.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].src.split('?')[0] === variant.featured_image.src.split('?')[0]) {
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
          break;
        }
      }
    }

    /* button */
    var btn = qv.querySelector('.lc-qv__atc');
    if (!variant) {
      btn.disabled = true;
      btn.textContent = 'Unavailable';
    } else if (!variant.available) {
      btn.disabled = true;
      btn.textContent = 'Sold Out';
    } else {
      btn.disabled = false;
      btn.textContent = 'Add To Cart';
    }
  }

  function onQuickViewAdd() {
    var qv = quickView;
    var variant = currentVariant();
    if (!variant || !variant.available) return;
    var btn = qv.querySelector('.lc-qv__atc');
    var err = qv.querySelector('.lc-qv__error');
    err.hidden = true;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding…';
        addToCart(variant.id, 1, state.sellingPlanId)
      .then(function () {
        btn.classList.remove('is-loading');
        btn.textContent = 'Add To Cart';
        btn.disabled = false;
        closeQuickView();
      })
      .catch(function (e) {
        btn.classList.remove('is-loading');
        btn.textContent = 'Add To Cart';
        btn.disabled = false;
        err.textContent = e.message || 'Could not add to cart';
        err.hidden = false;
      });
  }

  /* ------------------------------------------------------------------ */
  /*  <lc-quick-add> custom element                                      */
  /* ------------------------------------------------------------------ */
  var productCache = {};

  class LcQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this._lcBound) return;
      this._lcBound = true;
      var trigger = this.querySelector('button') || this;
      trigger.addEventListener('click', this.onTrigger.bind(this));
    }

    onTrigger(e) {
      e.preventDefault();
      e.stopPropagation();
      var btn = this.querySelector('button');
      if (btn && (btn.disabled || btn.classList.contains('is-loading'))) return;

      var hasVariants = this.dataset.hasVariants === 'true';
      if (!hasVariants && this.dataset.variantId) {
        this.directAdd(btn);
      } else {
        this.openView(btn);
      }
    }

    directAdd(btn) {
      var self = this;
      this.setLoading(btn, true);
            addToCart(this.dataset.variantId, 1, this.dataset.sellingPlanId)
        .then(function () { self.setLoading(btn, false); })
        .catch(function (err) {
          self.setLoading(btn, false);
          console.warn('[lc-quick-add]', err);
        });
    }

    openView(btn) {
      var self = this;
      var url = this.dataset.productUrl;
      if (!url) return;
            var meta = {
        entries: parseInt(this.dataset.entries || '0', 10) || 0,
        multiplier: parseInt(this.dataset.multiplier || '0', 10) || 0,
        tier: this.dataset.tier || 'badge-red',
        sellingPlanId: this.dataset.sellingPlanId || null
      };
      if (productCache[url]) {
        openQuickView(productCache[url], meta);
        return;
      }
      this.setLoading(btn, true);
      fetch(url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('Product fetch failed');
          return r.json();
        })
        .then(function (product) {
          productCache[url] = product;
          self.setLoading(btn, false);
          openQuickView(product, meta);
        })
        .catch(function (err) {
          self.setLoading(btn, false);
          console.warn('[lc-quick-add]', err);
          window.location.href = url;
        });
    }

    setLoading(btn, on) {
      if (!btn) return;
      btn.classList.toggle('is-loading', !!on);
      btn.toggleAttribute('data-loading', !!on);
    }
  }

  customElements.define('lc-quick-add', LcQuickAdd);
})();
